import React from "react";
import moment from "moment";
import ReactDOM from "react-dom";
import Toast from "components/Toast";
import { get, set, storageKey } from "./storage";
import { fileDownloadUrl } from "src/services/api";

/**
 * 遍历获取对应code数组
 *
 * @export
 * @param {string} code
 * @param {Record<string, any>} [data=[]]
 * @return {*}
 */
export function getArrByCode(code = "", data = []) {
  let arr = [];
  data?.forEach((element) => {
    const { children, ...rest } = element;
    arr.push(rest[code]);
    if (children?.length > 0) {
      arr = arr.concat(getArrByCode(code, children));
    }
  });
  return arr;
}

/**
 * 获取映射后的字段
 *
 * @export
 * @param {*} [data={}]
 * @param {string} [mapStr=""] eg. mapStr = "{count}次"
 * @return {*} 
 */
// export function getValueByMapStr(data = {}, mapStr = "") {
//   if (!data) return ""
//   const keyArr = Object.keys(data)
//   if (keyArr?.length > 0) {
//     keyArr.forEach(element => {
//       if (mapStr.includes(`{${element}}`)) {
//         // eslint-disable-next-line
//         mapStr = mapStr.replace(new RegExp(`{${element}}`, 'g'), data[element]);
//       }
//     });
//   }
//   return mapStr
// }

/**
 * 判断手机号
 * @param {string} phone 
 * @returns 
 */
export const isTellPhone = (phone) => {
  const reg = /^((\+|00)86)?1((3[\d])|(4[5,6,7,9])|(5[0-3,5-9])|(6[5-7])|(7[0-8])|(8[\d])|(9[1,8,9]))\d{8}$/;
  return reg.test(phone);
}

/**
 * 判断座机
 * @param {string} phone 
 * @returns 
 */
export const isLandline = (phone) => {
  const reg = /\d{3}-\d{8}|\d{4}-\d{7}/;
  return reg.test(phone);
}

/**
 * 判断邮箱
 * @param {string} email 
 * @returns 
 */
export const isEmail = (email) => {
  const reg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  return reg.test(email);
}

/**
 * 判断银行卡号
 * @param {string} card 
 * @returns 
 */
export const isBankCard = (card) => {
  const reg = /^([1-9]{1})(\d{15}|\d{18})$/;
  return reg.test(card);
}

/**
 * 判断网址
 * @param {string} url 
 * @returns 
 */
export const isHttps = (url) => {
  const reg = /^((https?|ftp):\/\/)?([\da-z.-]+)\.([a-z.]{2,6})(\/\w\.-]*)*\/?/;
  return reg.test(url);
}

// =================== toast ================
/**
 * 
 * @param {
 *  msg: string,
 *  severity: string,
 * } options 
 */
export const toast = (options) => {
  const ele = document.getElementById("toast-root");
  const dom = document.createElement("div");
  ele.appendChild(dom);
  ReactDOM.render(
    <Toast open={true} {...options} />,
    dom
  );

  setTimeout(() => {
    ReactDOM.unmountComponentAtNode(dom);
    ele.removeChild(dom)
  }, options?.autoHideDuration || 3000);
}
// =================== toast ================
/**
 * 时间转换
 * @param {时间戳} timestamp 
 * @param {转换格式} format 
 * @returns 
 */
export const getTime = (timestamp, format) => {
  if (timestamp) {
    return moment(timestamp).format(format || "YYYY/MM/DD hh:mm:ss");
  }
  return "";
}

/**
 * 下载文件
 *
 * @export
 * @param {*} {
 *   params,
 *   url = fileDownloadUrl
 * }
 */
export function downloadFile({
  params,
  url
}) {
  let paramsStr = '';
  let _url = url || fileDownloadUrl;
  if (params) {
    for (const p in params) {
      if (params[p]) paramsStr += p + '=' + params[p] + '&';
    }
  }
  if (!_url.includes('token=')) {
    paramsStr += `token=${get(storageKey.userInfo)?.token || ''}`;
  }
  if (paramsStr !== '') _url += '?' + paramsStr;
  toast({ msg: "请耐心等待下载...", severity: "info" });
  window.location.href = encodeURI(_url);
}

/**
 * 锚点定位
 *
 * @export
 * @param {*} anchorId 目标锚点id
 */
export function scrollToAnchor(anchorId) {
  if (anchorId) {
    // 修复路径上加了hash值找不到锚点
    anchorId = anchorId.replace("#", "");
    // 找到锚点
    let anchorElement = document.getElementById(anchorId);
    // 如果对应id的锚点存在，就跳转到锚点
    if (anchorElement) {
      anchorElement.scrollIntoView({ behavior: 'smooth' })
    }
  }
}

/**
 * 图片转base64
 *
 * @export
 * @param {*} img
 * @return {*} 
 */
export async function img2Base64(img) {
  return new Promise((resolve, reject) => {
    const imgSrc = img; // 图片本地路劲
    const image = new Image()
    image.src = imgSrc
    image.onload = () => {
      const canvas = document.createElement("canvas")
      canvas.width = image.width
      canvas.height = image.height
      const ctx = canvas.getContext("2d")
      ctx.drawImage(image, 0, 0, image.width, image.height)
      const ext = image.src.substring(image.src.lastIndexOf(".") + 1).toLowerCase()
      const dataUrl = canvas.toDataURL("image/" + ext)
      const base64 = JSON.parse(JSON.stringify(dataUrl)) // 这里就是转化成的编码
      resolve(base64)
    }
  })
}

export const getFileName = (path) => {
  if (typeof path === "string") {
    return path.replace(/[^\\/]*[\\/]+/g, '');
  }
  return "";
}

/**
 * 获取路径中的文件名
 *
 * @export
 * @param {*} path
 * @return {*} 
 */
export function getPathFileName(path) {
  let fileName = ''
  if (!path) return fileName
  fileName = path.substring(path.lastIndexOf('/') + 1, path.length)
  return fileName
}

/**
 * 跳转首页订购业务
 *
 * @export
 * @param {*} tabIdx
 * @param {*} history
 */
export function goHomeBusiness(tabIdx, history) {
  set(storageKey.anchorId, "homeBusiness")
  set(storageKey.homeOrderTabValue, tabIdx)
  history?.replace("/home")
}

/**
 * 运算方法（保留精度）
 *
 * @return {*}
 */
 export const floatObj = () => {

  /*
   * 判断obj是否为一个整数
   */
  function isInteger(obj) {
    return Math.floor(obj) === obj
  }

  /*
   * 将一个浮点数转成整数，返回整数和倍数。如 3.14 >> 314，倍数是 100
   * @param floatNum {number} 小数
   * @return {object}
   *   {times:100, num: 314}
   */
  function toInteger(floatNum) {
    const ret = { times: 1, num: 0 }
    if (isInteger(floatNum)) {
      ret.num = floatNum
      return ret
    }
    const strfi = floatNum + ''
    const dotPos = strfi.indexOf('.')
    const len = strfi.substr(dotPos + 1).length
    const times = Math.pow(10, len)
    const intNum = parseInt(String(floatNum * times + 0.5), 10)
    ret.times = times
    ret.num = intNum
    return ret
  }

  /*
   * 核心方法，实现加减乘除运算，确保不丢失精度
   * 思路：把小数放大为整数（乘），进行算术运算，再缩小为小数（除）
   *
   * @param a {number} 运算数1
   * @param b {number} 运算数2
   * @param digits {number} 精度，保留的小数点数，比如 2, 即保留为两位小数
   * @param op {string} 运算类型，有加减乘除（add/subtract/multiply/divide）
   *
   */
   //@ts-ignore
   function operation(a, b, digits, op) {
     const o1 = toInteger(a)
     const o2 = toInteger(b)
     const n1 = o1.num
     const n2 = o2.num
     const t1 = o1.times
     const t2 = o2.times
     const max = t1 > t2 ? t1 : t2
     let result = null
     switch (op) {
       case 'add':
         if (t1 === t2) { // 两个小数位数相同
           result = n1 + n2
         } else if (t1 > t2) { // o1 小数位 大于 o2
           result = n1 + n2 * (t1 / t2)
         } else { // o1 小数位 小于 o2
           result = n1 * (t2 / t1) + n2
         }
         return result / max
       case 'subtract':
         if (t1 === t2) {
           result = n1 - n2
         } else if (t1 > t2) {
           result = n1 - n2 * (t1 / t2)
         } else {
           result = n1 * (t2 / t1) - n2
         }
         return result / max
       case 'multiply':
         result = (n1 * n2) / (t1 * t2)
         return result
       case 'divide':
         result = (n1 / n2) * (t2 / t1)
         return result
       default:
         return ''
     }
   }

  // 加减乘除的四个接口
  function add(a, b, digits) {
    return operation(a, b, digits, 'add')
  }
  function subtract(a, b, digits) {
    return operation(a, b, digits, 'subtract')
  }
  function multiply(a, b, digits) {
    return operation(a, b, digits, 'multiply')
  }
  function divide(a, b, digits) {
    return operation(a, b, digits, 'divide')
  }

  // exports
  return {
    add: add,
    subtract: subtract,
    multiply: multiply,
    divide: divide
  }
}